import { Router } from 'vue-router'
import { store } from "../../store";
import { UserAuthStatus } from "./types";
import { BACKEND_SERVER } from '../common/env';


let gbl_router: Router

export function init_auth(arg_router: Router) {
    gbl_router = arg_router
}

export function get_site_auth_header() {
    return {
        "Session-Key": get_cookie('SESSION_KEY')
    }
}

export function is_authed() {
    return !!get_cookie("SESSION_KEY")
}

export function set_login_credentials(arg_session_key) {
    set_cookie("SESSION_KEY", arg_session_key, 30)
}

export function clear_login_credentials() {
    delete_cookie('SESSION_KEY')
    gbl_router.push('/login')
}

function get_cookie(arg_cookie_name) {
    let loc_name = arg_cookie_name + "=";
    let loc_decoded_cookie = decodeURIComponent(document.cookie);
    let loc_cookie_strings = loc_decoded_cookie.split(';');
    for(let tmp_cookie_index = 0; tmp_cookie_index <loc_cookie_strings.length; tmp_cookie_index++) {
        let tmp_cookie_string = loc_cookie_strings[tmp_cookie_index];
        while (tmp_cookie_string.charAt(0) == ' ') {
            tmp_cookie_string = tmp_cookie_string.substring(1);
        }
        if (tmp_cookie_string.indexOf(loc_name) == 0) {
            return tmp_cookie_string.substring(loc_name.length, tmp_cookie_string.length);
        }
    }
    return "";
}

function set_cookie(arg_cookie_name, arg_cookie_value, arg_days_until_expiration) {
    const loc_date = new Date();
    loc_date.setTime(loc_date.getTime() + (arg_days_until_expiration*24*60*60*1000));
    
    let loc_cookie_expires_at = "expires="+ loc_date.toUTCString();
    document.cookie = arg_cookie_name + "=" + arg_cookie_value + ";" + loc_cookie_expires_at + ";path=/" + ";Priority=High";;
}

function delete_cookie(arg_cookie_name) {
    if (get_cookie(arg_cookie_name)) {
        document.cookie = arg_cookie_name + "=" +
        ";path=/" +
        ";expires=Thu, 01 Jan 1970 00:00:01 GMT"        
    }
}

export async function check_user_auth_status(): Promise<boolean> {
    try {
        const check_user_auth_status_response = await fetch(BACKEND_SERVER + '/user-status',
            {
                headers: get_site_auth_header(),
            }
        )

        if (check_user_auth_status_response.status != 200) {
            console.error("Error checking user status", await check_user_auth_status_response.text(), check_user_auth_status_response.status)
        }
    
        let user_auth_status = await check_user_auth_status_response.json() as UserAuthStatus
        
        if (!user_auth_status.is_user_authed) {
            if (is_authed()) {
                clear_login_credentials()
            }

            return false
        } else {
            const pinia_store = store()

            pinia_store.set_user_status(user_auth_status)
        }

        return true

    } catch (e) {
        //TODO add proper tracing
        console.log(e)
        throw e
    }

    return false
}
